import createAction from 'redux-actions/lib/createAction';

export const TOGGLE_COLLAPSE = 'filterActions/TOGGLE_COLLAPSE';
export const toggleCollapse = createAction(TOGGLE_COLLAPSE);
export const SET_COLLAPSE = 'filterActions/SET_COLLAPSE';
export const setCollapse = createAction(SET_COLLAPSE);
